import styled from "@emotion/styled";
import { Container } from "@mui/material";

export const StyledHeaderContainer = styled(Container)(({ theme, cssProps, textAlign }) => {
  const createResponsiveStyles = (styles) => {
    if (!styles || typeof styles !== "object") return {};

    let responsiveCSS = {};

    Object.entries(styles).forEach(([property, value]) => {
      if (typeof value === "object" && value !== null) {
        const breakpoints = ["xs", "sm", "md", "lg", "xl"];

        breakpoints.forEach((breakpoint) => {
          if (value[breakpoint] !== undefined) {
            if (breakpoint === "xs") {
              responsiveCSS[property] = value[breakpoint];
            } else {
              const mediaQuery = theme.breakpoints.up(breakpoint);
              if (!responsiveCSS[mediaQuery]) {
                responsiveCSS[mediaQuery] = {};
              }
              responsiveCSS[mediaQuery][property] = value[breakpoint];
            }
          }
        });
      } else {
        // Regular non-responsive value
        responsiveCSS[property] = value;
      }
    });

    return responsiveCSS;
  };

  const processedCssProps = createResponsiveStyles(cssProps);

  const processedTextAlign = textAlign ? createResponsiveStyles({ textAlign }) : {};

  return {
    padding: "0rem !important",
    margin: "1rem 0rem",
    ...processedTextAlign,
    ...processedCssProps,
  };
});
